import config from '../config';
import http from '@/utils/http';
import { logger } from '@/utils/screenEventsLogger';

export async function apiGetScreenSnapshot(screenId) {
  try {
    return await http.get(`${config.apiUrl}userapi/screen/${screenId}/snapshot`);
  } catch (error) {
    logger.addLog(`Screen snapshot API failed for screen ${screenId}: ${error?.message || 'NA'}`);
    return null;
  }
}
